import { render } from "./citiesComp.vue?vue&type=template&id=47b65d49&scoped=true&ts=true"
import script from "./citiesComp.vue?vue&type=script&lang=ts"
export * from "./citiesComp.vue?vue&type=script&lang=ts"

import "./citiesComp.vue?vue&type=style&index=0&id=47b65d49&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47b65d49"]])

export default __exports__